import { ModelBase } from 'store/model-base';

export class CmsSimSwap extends ModelBase {
    public static storeName: string = 'cmsSimSwap';

    public breadcrumbs: CmsSimSwapBreadcrumbs;
    public unrecognized: CmsSimAlignStart;
    public recognized: CmsSimAlignFlow;
    public deviceAlignApiFailure: CmsDeviceAlignApiFailure;
}
